import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Slider.css";

const BannerSlider = () => {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      const res = await axios.get("https://backend.aubattle.com/api/banner/all");
      setBanners(res.data);
    } catch (err) {
      console.error("Failed to fetch banners", err);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [banners]);

  if (!banners.length) return null;

  return (
    <div className="slider-container">
      <div className="slider">
        {/* Ensure the URL in the banner is complete */}
        <a href={banners[current].url} target="_blank" rel="noopener noreferrer">
          <img
            src={`https://backend.aubattle.com/uploads/${banners[current].image}`}
            alt="Banner"
            className="slider-image"
          />
        </a>
      </div>
      <div className="dots">
        {banners.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default BannerSlider;
